// src/pages/Home/HomePage.jsx

import React from "react";
import HomeCarousel from "../../component/Home/HomeCarosel/HomeCarousel";
import Solutions from "../../component/Home/Solutions/Solutions";
import ExpertiseArea from "../../component/Home/ExpertiseArea/ExpertiseArea";
import OurPartners from "../../component/Home/OurPartners/OurPartners";
import OurClients from "../../component/Home/OurClients/OurClients";
import ContactForm from "../../component/ContactUs/ContactUsForm/ContactForm";
import TestimonialSection from "../../component/Home/testimonials/TestimonialSection";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HomeOverview from "../../component/Home/HomeOverview/HomeOverview";
import FloatingContactUs from "../../component/floting_contact/FloatingContactUs";
import { Helmet } from "react-helmet-async";

const HomePage = () => {
  return (
    <>
      {/* ✅ Meta Tags for SEO */}
      <Helmet>
        <title>PLM Consulting & Services Company in Pune | Innovative Product Lifecycle Management | NexTech PLM Solutions</title>
        <meta name="description" content="NexTech PLM is one of the top PLM companies in Pune and India, offering end-to-end PLM consulting and services including implementation, integration, and support. Enhance your product lifecycle management-get in touch with our experts today!" />
        <meta name="keywords" content="NexTech PLM Solutions, PLM services Pune, Teamcenter implementation, MCAD ECAD integration, Polarion ALM, Opcenter MES, Mendix low-code, product lifecycle management India" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href="https://nextechplm.com/" />
        <meta property="og:site_name" content="NexTech PLM Solutions" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="NexTech PLM Solutions | Teamcenter PLM & Engineering Services" />
        <meta property="og:description" content="NexTech PLM Solutions specializes in Teamcenter PLM implementation, CAD/ERP integration, document management, data migration, and digital transformation services for global enterprises." />
        <meta property="og:url" content="https://nextechplm.com/" />
        <meta name="twitter:title" content="NexTech PLM Solutions | Teamcenter PLM & Engineering Services" />
        <meta name="twitter:description" content="NexTech PLM Solutions specializes in Teamcenter PLM implementation, CAD/ERP integration, document management, data migration, and digital transformation services for global enterprises." />
      </Helmet>

      <ToastContainer />

      {/* 🔥 Hero: video + Siemens glass card + rotating headline */}
      <HomeCarousel />

      <FloatingContactUs />
      <HomeOverview />
      <Solutions />
      <ExpertiseArea />
      <OurPartners />
      <OurClients />
      <TestimonialSection showHelmet={false} />
      <ContactForm />
    </>
  );
};

export default HomePage;

      
     
